import {Component} from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import {OrderService} from "../../services/OrderService";
import {Activity, Order, OrderStatus} from "../../model/Order";
import {SubmitMissionCustomerCancellation} from "../../model/OrderRequest";
import {OperationService} from "../../services/OperationService";
import {AuthService} from "../../services/AuthService";
import {OrderInfo} from "../nav/OrderInfo";
import {PhotoService} from "../../services/PhotoService";
import {DateService} from "../../services/DateService";
import {Cra} from "../../model/Cra";
import {MissionReportPhoto} from "../../model/MissionReportPhoto";
import {InAppBrowser, InAppBrowserOptions} from '@ionic-native/in-app-browser';
import {apiconfig} from "../../app/api.config";
import {DatePipe} from "@angular/common";
import {AdditionalTimesViewPage} from "./additional/additional-view";
import {CustomerFeedBackCommentValue, CustomerFeedBackValue} from "../../model/CustomerFeedBackValue";
import {Pcheck} from "../../model/Pcheck";
import {Operation, OperationCustomerPlanningSetting} from "../../model/Operation";
import {StoreDashboardPage} from "../store-dashboard/store-dashboard";

/**
 * Generated class for the OrderViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

export class SelectedFile {
  type: string;
  name: string;
}

export class WdPhotoContainer {
  id: number;
  photos: MissionReportPhoto[] = [];
}

export class StatusRenderingDto {
  cssStatus: string;
  label: string;
  message: string;
  icon: string;

  workerEmail: string;
  workerPhone: string;

  setup(order: Order) {
    this.cssStatus = order.cssStatus();
    this.label = order.toHrStatus();
    if (order.status === OrderStatus.PENDING_VALIDATION) {
      this.icon = "cog";
      this.message = "Votre demande est en attente de validation";
    } else if (order.status === OrderStatus.VALIDATED) {
      this.icon = "thumbs-up";
      this.message = "Votre demande est validée, la recherche et l'affectation d'un intervenant est en cours.";
    } else if (order.status === OrderStatus.ASSIGNED) {
      this.icon = "contact";
      this.message = "Un intervenant a été affecté à votre demande d'intervention";
    } else if (order.status === OrderStatus.REJECTED) {
      this.icon = "thumbs-down";
      this.message = "Nos équipes n'ont pas été en mesure d'intégrer votre demande.";
    } else if (order.status === OrderStatus.FULFILLED) {
      this.icon = "thumbs-up";
      this.message = "L'intervention a été menée à bien.";
    } else if (order.status === OrderStatus.CANCELED) {
      this.icon = "close";
      this.message = "Votre demande n'est plus d'actualité.";
    }
  }
}

@Component({
  selector: 'page-order-view',
  templateUrl: 'order-view.html',
})
export class OrderViewPage {

  public iconsURL: string = apiconfig.LOGA_ICONS;
  public apiConfig: any = apiconfig;


  /**
   * array of pre-loaded presence checks
   */
  private presChecks: Pcheck[];

  /**
   * the order we are currently checking
   */
  protected order: Order;

  /**
   * container to store data cancellation
   */
  private submitCancellation: SubmitMissionCustomerCancellation;

  protected planificationSettings: OperationCustomerPlanningSetting;
  protected customerFeedBackOptions: CustomerFeedBackValue[];

  protected uiFeedbackHowManyStars: number;
  protected uiShowCancelZone: boolean;

  protected uiPhotoPerActivity: WdPhotoContainer[] = [];
  protected uiOrderStatus: StatusRenderingDto;

  imgPreviewStyle: any;
  customerFeedBackCommentOptions: CustomerFeedBackCommentValue[];
  uiShowComment: boolean;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public orderService: OrderService,
              public operationService: OperationService,
              public authService: AuthService,
              public photoService: PhotoService,
              public dateService: DateService,
              private alertCtrl: AlertController,
              private datePipe: DatePipe,
              private iab: InAppBrowser) {
  }


  /**
   * Before show the page, we need to load order info, operation kits and operation profils
   *
   * WARNING we must keep it on IonViewDidLoad otherwise it will be triggered with day changes
   */
  ionViewDidLoad() {
    console.log("ionViewDidLoad -- OrderViewPage")
    this.uiShowComment = false;
    let orderInfo: OrderInfo = this.navParams.data['orderInfo'];
    this.presChecks = this.navParams.data['pchecks'];
    this.uiShowCancelZone = false;

    // -- initialise mission cancellation dto
    this.submitCancellation = new SubmitMissionCustomerCancellation();

    this.orderService.loadOrder(orderInfo.order).then((order: Order) => {

      this.order = order;
      this.uiOrderStatus = new StatusRenderingDto();
      this.uiOrderStatus.setup(order);

      this.orderService.loadCustomerFeedBackValueList().then((response) => {
        this.customerFeedBackOptions = response.reverse();
        this.processHowManyStars();
      });

      this.orderService.loadCustomerFeedBackCommentValueList().then((response) => {
        this.customerFeedBackCommentOptions = response.reverse();
      });

      // consider that feedBackComment can be negative only, then auto-declare incident
      this.order.uiIncidentDeclared = this.order.customerFeedbackComment != null;

      this.operationService
        .loadOperationCustomerPlanningSettings(this.order.operation.id)
        .then(response => {
          this.planificationSettings = response;
          this.imgPreviewStyle = this.computeBackUrl(order.operation);

          // display worker name if okay
          if (this.planificationSettings.shareAssignedWorkerInfoByEmail && this.order.worker != null) {
            this.uiOrderStatus.message = "Collaborateur Affecté : " + this.order.worker.workerName;
            this.uiOrderStatus.workerPhone = this.order.worker.workerMobilePhone;
            // update, we don't want to show the email, at least for now
            //this.uiOrderStatus.workerEmail = this.order.worker.workerEmail;

          } else {
            this.uiOrderStatus.workerPhone = null;
            this.uiOrderStatus.workerEmail = null;
          }
        });


      this.photoService.searchPhoto(null, null, this.order.operation.id, null, [this.order.id])
        .then((response) => {
            let photoReports: MissionReportPhoto[] = response;

            if (photoReports != null && photoReports.length > 0) {

              const logaToken: string = this.authService.buildLogaToken();
              let animaToken: string;
              console.log(photoReports)
              /// set url for each pictures
              photoReports.forEach((ph) => {

                if (this.uiPhotoPerActivity[ph.activityId] == null) {
                  console.log('adding 1 for activity ' + ph.activityId)
                  this.uiPhotoPerActivity[ph.activityId] = new WdPhotoContainer();
                  this.uiPhotoPerActivity[ph.activityId].id = ph.activityId;
                }

                let phContainer = this.uiPhotoPerActivity[ph.activityId];

                switch (ph.source) {
                  case "PCHECK":
                    ph.urlPicture = ph.urlPicture + "&jtkn=" + logaToken;
                    ph.urlPicture = ph.urlPicture.replace('thumb=true', 'thumb=false');
                    phContainer.photos.push(ph);
                    break;
                  case "COACHING":
                    ph.urlPicture = ph.urlPicture + "&jtkn=" + logaToken;
                    phContainer.photos.push(ph);
                    break;
                  case "ANIMA_TAG_PHOTO":
                    if (ph.logaWorkDayId != null) {
                      animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                      ph.urlPicture = ph.urlPicture + '&thumb=1' + "&tkn=" + animaToken;
                      phContainer.photos.push(ph);
                    }
                    break;
                  case "ANIMA_ISA_PHOTO":
                    if (ph.logaWorkDayId != null) {
                      animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                      ph.urlPicture = ph.urlPicture + '&thumb=1' + "&tkn=" + animaToken;
                      phContainer.photos.push(ph);
                    }
                    break;
                  case "ANIMA_PRODUCT_PHOTO":
                    if (ph.logaWorkDayId != null) {
                      animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                      ph.urlPicture = ph.urlPicture + '&thumb=1' + "&tkn=" + animaToken;
                      phContainer.photos.push(ph);
                    }
                    break;
                  default:
                    console.log("Unknown source:" + ph.source)
                    break;
                }

              });

            }

          },
          () => {

          }
        );


    });

  }


  private processHowManyStars() {
    this.uiFeedbackHowManyStars = 0;
    if (this.order.customerFeedback != null) {
      for (let i = 0; i < this.customerFeedBackOptions.length; i++) {
        if (this.customerFeedBackOptions[i].value == this.order.customerFeedback)
          this.uiFeedbackHowManyStars = this.customerFeedBackOptions[i].rank;
      }
    }
  }

  public datePhoto(referenceDate: number): Date {
    return this.dateService.toDate(referenceDate);
  }


  displayDateDivider(act: Activity) {
    const datepipe: DatePipe = new DatePipe('fr-FR')
    let formattedDate = datepipe.transform(new Date(act.day * 86400000), 'EEE dd MMM yyyy');
    return formattedDate;
  }

  displayWorkHours(act: Activity): string {
    const datepipe: DatePipe = new DatePipe('fr-FR')
    let h: string = '';

    if (act.amStartTime != null)
      h += datepipe.transform(act.amStartTime, 'HH:mm');
    if (act.amEndTime != null)
      h += " - " + datepipe.transform(act.amEndTime, 'HH:mm');

    if (act.amStartTime != null && act.amEndTime != null)
      h += "<br/>";

    if (act.pmStartTime != null)
      h += datepipe.transform(act.pmStartTime, 'HH:mm');
    if (act.pmEndTime != null)
      h += " - " + datepipe.transform(act.pmEndTime, 'HH:mm');


    return h;
  }

  public showPresenceCheck(): boolean {
    return this.planificationSettings != null && this.planificationSettings.showPresenceCheckInfos;
  }


  onViewEvaluation() {


  }

  onViewAdditionalTimes() {
    this.navCtrl.push(AdditionalTimesViewPage, this.order);
  }

  setFeedBack(value: string) {
    console.log("setFeedBack:" + value);
    this.orderService.updateCustomerFeedBack(this.order.id, value).then(r => {
      this.order.customerFeedback = value;
      if (value == 'DISAPPOINTING')
        this.uiShowComment = true;
      else {
        this.setFeedBackComment(null)
      }
      this.order.customerFeedbackComment = null;
      this.processHowManyStars();
    });
    this.order.customerFeedbackComment = null;
  }

  setFeedBackComment($event) {
    this.orderService.updateCustomerFeedBackComment(this.order.id, $event).then(r => {
      this.order.customerFeedbackComment = $event;
      this.uiShowComment = false;
    });
  }

  /**
   *
   */
  public isCraDisplayAllowed(p_cra: Cra): boolean {

    if (this.planificationSettings !== undefined) {
      if ("PUBLISHED" === this.planificationSettings.showCra) {
        return p_cra.published;
      } else if ("YES" === this.planificationSettings.showCra) {
        return true;
      } else
        return false;
    }
    return false;
  }


  /**
   *
   * @param id
   * @param i
   */
  onViewCRA(cra: Cra) {

    if (this.isCraDisplayAllowed(cra)) {

      let options: InAppBrowserOptions = {
        location: 'yes',//Or 'no'
        hidden: 'no', //Or  'yes'
        clearcache: 'yes',
        clearsessioncache: 'yes',
        zoom: 'yes',//Android only ,shows browser zoom controls
        hardwareback: 'yes',
        mediaPlaybackRequiresUserAction: 'no',
        shouldPauseOnSuspend: 'no', //Android only
        closebuttoncaption: 'Close', //iOS only
        disallowoverscroll: 'no', //iOS only
        toolbar: 'yes', //iOS only
        enableViewportScale: 'no', //iOS only
        allowInlineMediaPlayback: 'no',//iOS only
        presentationstyle: 'pagesheet',//iOS only
        fullscreen: 'yes',//Windows only
      };

      let animaToken: string = this.authService.buildAnimaInputFieldToken(cra.id);

      let target = "_system";
      // TODO - voir effet sur le portail
      this.iab.create(this.apiConfig.ANIMA_REPORTS_URL + "/" + cra.id + "/jstart.html?tkn=" + animaToken, target, options);
      // this.iab.create("http://anima.agence-impact.com/reports" + "/" + cra.id + "/jstart.html?tkn=" + animaToken, target, options);

    } else {

      let alert = this.alertCtrl.create({
        title: 'Compte-rendu',
        subTitle: "Ce compte-rendu n'est pas disponible pour le moment.",
        buttons: ['Fermer'],
      });
      alert.present();

    }

  }

  showCancelZone() {
    this.uiShowCancelZone = true;
  }

  submitCancel() {
    this.orderService.submitCancel(this.order.id, this.submitCancellation).then(() => {
      let alert = this.alertCtrl.create({
        title: 'Annulation',
        subTitle: "Votre demande d'annulation a été soumise.",
        buttons: ['Fermer'],
      });
      alert.present();

    });
  }

  computeBackUrl(opCard: Operation): any {
    console.log('computeBackUrl');
    return {
      "background": "url('https://contact-loga2.agence-impact.com/resources/operation/" + opCard.id + "/banner') center repeat black",
      "background-size": "cover",
      "width": "100%",
      "height": "64px"
    };
  }
  openStoreDashboard() {
    this.navCtrl.push(StoreDashboardPage, {'storeId': this.order.location.id})
  }

  declareIncident($event) {
    if ($event.value)
      this.setFeedBack('DISAPPOINTING');
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-view/order-view.ts